import { ClipboardCopyButton } from '@neo/blocks/clipboard-copy-button'
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter'
import bash from 'react-syntax-highlighter/dist/esm/languages/hljs/bash'
import js from 'react-syntax-highlighter/dist/esm/languages/hljs/javascript'
import jsonLang from 'react-syntax-highlighter/dist/esm/languages/hljs/json'
import atomOneDark from 'react-syntax-highlighter/dist/esm/styles/hljs/atom-one-dark'
import docco from 'react-syntax-highlighter/dist/esm/styles/hljs/docco'
import { useAppStore } from 'v2/state/app'

// The Light build highlights only what is registered — an unregistered language renders plain.
SyntaxHighlighter.registerLanguage('javascript', js)
SyntaxHighlighter.registerLanguage('json', jsonLang)
SyntaxHighlighter.registerLanguage('bash', bash)

interface CodeBlockProps {
  code: string
  language?: string
  showCopyButton?: boolean
  clipboardCopyButtonPosition?: 'topRight' | 'bottomRight'
}

export const CodeBlock = ({
  code,
  language = 'javascript',
  showCopyButton = true,
  clipboardCopyButtonPosition = 'bottomRight',
}: CodeBlockProps) => {
  // docco paints its base text #000, which is unreadable on the dark-mode hv1 surface.
  const isDarkMode = useAppStore((state) => state.isDarkMode)

  return (
    <div className="relative group">
      <SyntaxHighlighter
        language={language}
        style={isDarkMode ? atomOneDark : docco}
        className="!bg-hv1 !p-4 [&_code]:text-sm rounded-lg"
        customStyle={{
          width: '100%',
          minWidth: '100%',
        }}
      >
        {code}
      </SyntaxHighlighter>
      {showCopyButton && (
        <ClipboardCopyButton
          textToCopy={code}
          data-testid="btn-copy-code"
          position={clipboardCopyButtonPosition}
        />
      )}
    </div>
  )
}
